module.exports = __webpack_public_path__ + "static/media/X1_ROUGH.2702c141.png";